import React from "react";
import { ReactChildrenProps } from "../types/ReactChildrenProps";

interface ErrorLoggerProps extends ReactChildrenProps {}

export class ErrorLogger extends React.Component<ErrorLoggerProps> {
  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // this will catch uncatched errors from the react components lifecycle...
  }

  public componentWillMount() {
    const prevOnError = window.onerror;

    // ... and this will catch any other errors, from promises etc.
    window.onerror = (
      message: string | Event,
      source?: string,
      fileno?: number,
      columnNumber?: number,
      error?: Error
    ) => {
      if (prevOnError) {
        prevOnError(message, source, fileno, columnNumber, error);
      }

      // LogService.logException({
      //   error: error || new Error(message ? message.toString() : ""),
      // });
    };
  }

  public render() {
    return this.props.children;
  }
}
